import React from 'react';
import { motion } from 'framer-motion';
import SectionHead from '../ui/SectionHead';
import Reveal from '../ui/Reveal';
import Spotlight from '../ui/Spotlight';
import { skills, certifications } from '../../data/profile';
import './Skills.css';

const list = {
  hidden: {},
  show: { transition: { staggerChildren: 0.035 } },
};

const chip = {
  hidden: { opacity: 0, y: 10, scale: 0.96 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] } },
};

export default function Skills() {
  return (
    <section className="section skills" id="skills">
      <div className="container">
        <SectionHead
          index="05"
          label="Toolbox"
          title={[{ text: 'Boring,' }, { text: 'reliable', em: true }, { text: 'tools. Used in anger.' }]}
          aside={<p className="small">The stack I reach for first, and the one I can debug at 2am.</p>}
        />

        <div className="skills__grid">
          {skills.map((g, i) => (
            <Reveal key={g.group} delay={(i % 3) * 0.08} className={g.featured ? 'skills__cell skills__cell--wide' : 'skills__cell'}>
              <Spotlight className="card skills__card" color="rgba(203, 185, 150, 0.12)">
                <div className="skills__head">
                  <span className="mono accent">0{i + 1}</span>
                  <h3 className="skills__title">{g.group}</h3>
                </div>
                <motion.ul
                  className="skills__list"
                  variants={list}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.4 }}
                >
                  {g.items.map((it) => (
                    <motion.li key={it} className="skills__chip" variants={chip}>
                      {it}
                    </motion.li>
                  ))}
                </motion.ul>
              </Spotlight>
            </Reveal>
          ))}
        </div>

        <Reveal className="certs" delay={0.1}>
          <span className="mono">Certifications</span>
          <ul className="certs__list">
            {certifications.map((c) => (
              <li key={c.name}>
                <span className="certs__name">{c.name}</span>
                <span className="certs__issuer mono">{c.issuer}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
